import { ArrowRight } from '@/components/icons/ArrowRight';
import { Box, Button, useMantineTheme } from '@mantine/core';

type ScheduleCallLinkProps = {
  onClick: () => void;
  label?: string;
};

export const ScheduleCallLink = ({ onClick, label = 'Schedule a Call' }: ScheduleCallLinkProps) => {
  const theme = useMantineTheme();

  return (
    <Box w="55%">
      <p
        style={{
          fontSize: theme.fontSizes.lg,
          color: theme.colors.neutral[4],
          textAlign: 'center',
          fontWeight: 400,
          marginTop: 0,
        }}
      >
        or
      </p>

      <Button
        fullWidth
        m="0 auto"
        variant="subtle"
        styles={(theme) => ({
          root: {
            fontWeight: 700,
            color: theme.colors.tertiary[2],
            fontSize: theme.fontSizes.lg,
            zIndex: 99,
            '&:hover': {
              backgroundColor: 'transparent',
              cursor: 'pointer',
            },
          },
        })}
        rightIcon={<ArrowRight fontWeight={700} />}
        onClick={onClick}
      >
        {label}
      </Button>
    </Box>
  );
};
